var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "site-header" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "nav-toggle",
        attrs: { href: "#" },
        on: { click: _vm.onNavToggle }
      },
      [_vm._m(1)]
    ),
    _vm._v(" "),
    _c("ul", { staticClass: "action-list" }, [
      _c("i", { staticClass: "breadcrumb-item" }),
      _vm._v(_vm._s(_vm.nombre) + "\n    "),
      _c(
        "li",
        [
          _c("v-dropdown", { attrs: { "show-arrow": false } }, [
            _c(
              "a",
              {
                staticClass: "notification",
                attrs: {
                  slot: "activator",
                  href: "#",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                },
                slot: "activator"
              },
              [
                _c("i", { staticClass: "icon-fa icon-fa-bell" }),
                _vm._v(" "),
                _c("span", { staticClass: "badge" }, [
                  _vm._v(_vm._s(_vm.getNumberNotifications(_vm.notifications)))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "notification-dropdown" },
              [
                _c("h6", { staticClass: "dropdown-header" }, [
                  _vm._v("Notificaciones")
                ]),
                _vm._v(" "),
                _vm._l(_vm.notifications, function(notification) {
                  return _c("v-dropdown-item", { key: notification.id }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function($event) {
                            return _vm.viewNotification(notification.id)
                          }
                        }
                      },
                      [
                        _c("i", { class: "icon-fa " + notification.icon }),
                        _vm._v(_vm._s(notification.message) + "\n            ")
                      ]
                    )
                  ])
                }),
                _vm._v(" "),
                _c(
                  "v-dropdown-item",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "dropdown-item",
                        attrs: { to: "/admin/notifications" }
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-eye" }),
                        _vm._v("Ver historial de notificaciones\n            ")
                      ]
                    )
                  ],
                  1
                )
              ],
              2
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "v-dropdown",
            { attrs: { "show-arrow": false } },
            [
              _c(
                "a",
                {
                  staticClass: "avatar",
                  attrs: {
                    slot: "activator",
                    href: "#",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  },
                  slot: "activator"
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/assets/img/avatars/avatar.png",
                      alt: "Avatar"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("v-dropdown-item", [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-sign-out" }),
                    _vm._v(" Cerrar sesión\n          ")
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "brand-main", attrs: { href: "#" } }, [
      _c("img", {
        staticClass: "d-none d-md-inline",
        staticStyle: { height: "30px" },
        attrs: { id: "logo-desk", src: "/assets/img/lacolima.png" }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "d-md-none",
        staticStyle: { height: "25px" },
        attrs: {
          id: "logo-mobile",
          src: "/assets/img/lacolima.png",
          alt: "Laraspace Logo"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hamburger hamburger--arrowturn" }, [
      _c("div", { staticClass: "hamburger-box" }, [
        _c("div", { staticClass: "hamburger-inner" })
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-555213ad", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555213ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/layouts/partials/TheSiteHeader.vue
// module id = 492
// module chunks = 0